export const SELECTED_COUNTRY = 'selected';

export const MARKETING_WEBSITE_DOMAINS = {
  'en-GB': 'https://sumup.co.uk',
  'en-IE': 'https://sumup.ie',
  'en-MT': 'https://sumup.com.mt',
  'en-US': 'https://sumup.com',
  'bg-BG': 'https://sumup.bg',
  'cs-CZ': 'https://sumup.cz',
  'da-DK': 'https://sumup.dk',
  'de-AT': 'https://sumup.at',
  'de-CH': 'https://ch-de.sumup.com',
  'de-DE': 'https://sumup.de',
  'de-LU': 'https://de.sumup.lu/',
  'el-CY': 'https://sumup.com.cy',
  'el-GR': 'https://sumup.gr',
  'es-CL': 'https://sumup.cl',
  'es-CO': 'https://sumup.co',
  'es-ES': 'https://sumup.es',
  'et-EE': 'https://sumup.ee',
  'fi-FI': 'https://sumup.fi',
  'fr-BE': 'https://fr.sumup.be/',
  'fr-CH': 'https://ch-fr.sumup.com',
  'fr-FR': 'https://sumup.fr',
  'fr-LU': 'https://fr.sumup.lu',
  'hr-HR': 'https://sumup.hr',
  'hu-HU': 'https://sumup.hu',
  'it-CH': 'https://ch-it.sumup.com',
  'it-IT': 'https://sumup.it',
  'lt-LT': 'https://sumup.lt',
  'lv-LV': 'https://sumup.lv',
  'nb-NO': 'https://sumup.no',
  'nl-BE': 'https://nl.sumup.be',
  'nl-NL': 'https://sumup.nl',
  'pl-PL': 'https://sumup.pl',
  'pt-BR': 'https://sumup.com.br',
  'pt-PT': 'https://sumup.pt',
  'ro-RO': 'https://sumup.ro',
  'sk-SK': 'https://sumup.sk',
  'sl-SI': 'https://sumup.si',
  'sv-SE': 'https://sumup.se',
  'es-PE': 'https://sumup.pe',
  'es-MX': 'https://sumup.mx',
  'en-AU': 'https://sumup.com.au',
};
